<template>
  <div class="view">
    <Title title="お知らせ"/>
    <InfoMain/>
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import InfoMain from '@/components/InfoMain'

export default {
  components: {
    Title,
    InfoMain
  },

  created: function () {
    this.$store.dispatch('info/retrieveInfos')
  }
}
</script>
